var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gi37n3x9fa)",
    fill: "#FDB525"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.643 9.286a4.643 4.643 0 1 1 0-9.286 4.643 4.643 0 0 1 0 9.286zm0-6.753a2.11 2.11 0 1 0 0 4.221 2.11 2.11 0 0 0 0-4.222zM15.358 9.286A4.643 4.643 0 1 1 15.355 0a4.643 4.643 0 0 1 .003 9.286zm0-6.753a2.11 2.11 0 1 0 0 4.22 2.11 2.11 0 0 0 0-4.22zM4.643 20a4.643 4.643 0 1 1 0-9.287 4.643 4.643 0 0 1 0 9.286zm0-6.753a2.11 2.11 0 1 0 0 4.218 2.11 2.11 0 0 0 0-4.218zM15.358 20a4.643 4.643 0 1 1 0-9.287 4.643 4.643 0 0 1 0 9.286zm0-6.753a2.11 2.11 0 1 0 0 4.218 2.11 2.11 0 0 0 0-4.218z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gi37n3x9fa"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.90e142e0c131856259fb4f838f7af2a8.svg";
export { ForwardRef as ReactComponent };